import React from 'react';
import '../assets/styles/FloatingButton.css'; // Asegúrate de tener los estilos

const FloatingButton = () => {
  const whatsappNumber = "5491134089621"; // Reemplaza con tu número de WhatsApp
  const message = "Hola, me gustaría obtener más información.";

  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappLink}
      className="floating-whatsapp"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat en WhatsApp"
      data-aos="zoom-in" // Animación específica
      data-aos-offset="50" // Desplazamiento antes de activar
      data-aos-duration="1000" // Duración de la animación
      data-aos-once="true" // Ejecutar solo una vez
    >
      <i className="fab fa-whatsapp"></i>
    </a>
  );
};

export default FloatingButton;